const dataFoodRice = [
  {
    id: 0,
    href: "/Detail-Own-Restaurant-Food-Rice",
    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C3MTGPLTNLM2JX/hero/94b3d5ba78d4497abd239486c538b5d8_1691126914228288809.webp",
    title: "CƠM TẤM 31 - BÀ HẠT",
    moreInfo: "Cơm",
    rating: 4.4,
    time: " 15 phút ",
    distance: " 1.3 km ",
    special: " Ưu đãi đến 130K ",
    warn: "",
    timeOpen: "Hôm nay \u00A0\u00A0\u00A0 07:30-20:00",
  },
  {
    id: 1,
    href: "/",
    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C6A1L7LHTYDKAJ/hero/7de9cdf681994dc8b3491f0d4502fb67_1701757811517994661.webp",
    title: "Cơm Tấm 358",
    moreInfo: "Cơm",
    rating: 4.3,
    time: " 20 phút ",
    distance: " 2.9 km ",
    special: " 🥢Bữa tối nửa giá🥢 🌟Quán ngon 22K🌟",
    warn: "",
  },
  {
    id: 2,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C6DGRRKTRA4YVT/hero/c0a13e9e984e450e9f338e77a9bf5c30_1706674074889583328.webp",
    title: "Cơm Tấm Long Xuyên Since 1989  ",
    moreInfo: "Cơm",
    rating: 3.8,
    time: " 20 phút ",
    distance: " 3.7km ",
    special: " 🔥Grab Ngon Rẻ🔥 Bao Giá & Bao Ship",
    warn: "",
  },
  {
    id: 3,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C3LWR3B3RTCKAX/hero/b27bf197ab294f5f8b2b5a0de11c782f_1697428409370937982.webp",
    title: "Xuyên Đêm Quán − Món Ngon 24/7 − Cách Mạng Tháng 8",
    moreInfo: "Cơm, Món Quốc Tế , Bún - Phở - Cháo, Ăn Vặt",
    rating: 4.3,
    time: " 15 phút ",
    distance: " 1.7km ",
    special: " Ưu đãi đến 46K ",
    warn: "",
  },
  {
    id: 4,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C33BFA6YET42JE/hero/64b6c416816e4eb29a512ca64e8fdede_1672138602364902267.webp",
    title: "Cơm Tấm Sườn Bì Chả Trứng - Thành Thái",
    moreInfo: "Cơm",
    rating: 2.4,
    time: " 15 phút ",
    distance: " 1.3km ",
    special: " Ưu đãi đến 52K ",
    warn: "",
  },
  {
    id: 5,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/5-CYVBC2MFHCJJN6/hero/4aa046ad806e484b85e2d9621b34f324_1670797051690808099.webp",
    title: "Cơm Tấm Thảo",
    moreInfo: "Cơm",
    rating: 4.2,
    time: " 20 phút ",
    distance: " 4.3km ",
    special: " Ưu đãi đến 52K ",
    warn: "",
  },
  {
    id: 6,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C4EFLXN1V3XTCT/hero/2024903f6f7d4633b2b8e0fa9a707bdd_1688555221010125671.webp",
    title: "CƠM TẤM - BÚN THỊT NƯỚNG ĐẠI NGÂN",
    moreInfo: "Cơm, Bún - Phở - Cháo",
    rating: 2.3,
    time: " 20 phút ",
    distance: " 1.3km ",
    special: " Ưu đãi lên đến 45K ",
    warn: "",
  },
  {
    id: 7,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/VNGFVN000006i6/hero/e6aceac9aaab4792b7cd8d1ed3c3b5da_1710867599880869023.webp",
    title: "McDonald's - Siêu Thị Sài Gòn",
    moreInfo: "Gà Rán - Burger, Cơm, Món Quốc Tế ",
    rating: 4.4,
    time: " 15 phút ",
    distance: " 1km ",
    special: " 🔥50K off, Combo Trưa Chỉ 40K ",
    warn: "",
  },
  {
    id: 8,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C6JXE3KCJABFN6/hero/7cb7aabac07f49ec9c758416e4a55729_1711429191607165169.webp",
    title: "Cơm Thố, Mì Xào Béo Food - CN3",
    moreInfo: "Cơm",
    rating: 5,
    time: " 15 phút ",
    distance: " 2.1km ",
    special: " Nhập QUANNGONNB giảm 25K cho đơn từ 25K ",
    warn: "",
  },
  {
    id: 9,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C3E3R7NBRPTFLA/hero/d318a5e50d5d40fca043af0ee4690d39_1670796835168527770.webp",
    title: "Bún thịt nướng Sài Gòn xưa",
    moreInfo: "Cơm",
    rating: 2.1,
    time: " 20 phút ",
    distance: " 3.3km ",
    special: " 🍽️Deal trưa 0Đ🍽️ 🥢Bữa tối nửa giá🥢 ",
    warn: "",
  },
  {
    id: 10,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/5-CY4KEUW3GXK3L2/hero/e33b3d758bdd4d0f84e74d2698ce3bbe_1691126913838870103.webp",
    title: "Bánh Cuốn Ba Miền - Trần Quang Khải",
    moreInfo: "Bún - Phở - Cháo, Cơm, Bánh Việt Nam",
    rating: 4.4,
    time: " 25 phút ",
    distance: " 4.3km ",
    special: " Ưu đãi đến 45K ",
    warn: "",
  },
  {
    id: 11,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C6DJKEKTGLAVKE/hero/287af98d-cca5-4dd0-8d8b-e90e414f5cd0__store_cover__2024__02__18__14__25__28.webp",
    title: "Mama Cà Ri – Curry 24/7 – Cách Mạng Tháng 8",
    moreInfo: "Cơm, Món Quốc Tế , Bún - Phở - Cháo",
    rating: 3.9,
    time: " 15 phút ",
    distance: " 1.7km ",
    special: " Ưu đãi đến 46K ",
    warn: "",
  },
  {
    id: 12,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C36JMAABENWWEN/hero/0085e8ee-7146-4a7e-8bb1-83d94385afd2__store_cover__2023__05__27__14__00__48.webp",
    title: "Cơm Gà Xối Mỡ - Mỳ Trộn Nam Vân",
    moreInfo: "Cơm, Bún - Phở - Cháo",
    rating: 3.3,
    time: " 20 phút ",
    distance: " 2.8km ",
    special: " 🍽️Deal trưa 0Đ🍽️ 🥢Bữa tối nửa giá🥢 ",
    warn: "",
  },
  {
    id: 13,
    href: "/",

    src: "https://food-cms.grab.com/compressed_webp/merchants/VNGFVN000002fc/hero/00022a0f7c8c408f8ddfce4d45191f45_1670796941069362021.webp",
    title: "Bún Bò Huế 149",
    moreInfo: "Bún - Phở - Cháo, Cơm",
    rating: 4.6,
    time: " 15 phút ",
    distance: " 0.8km ",
    special: " 🔥Món 33K🔥 ",
    warn: "",
  },
  {
    id: 14,
    href: "/",
    src: "https://food-cms.grab.com/compressed_webp/merchants/5-C3AKHADFA8M3RN/hero/c29c2648fc5241ba9fb654b62368c620_1670796634751804472.webp",
    title: "Cơm Tấm Sườn 25K",
    moreInfo: "Cơm",
    rating: 3.3,
    time: " 25 phút ",
    distance: " 5.1km ",
    special: " 🔥Grab Ngon Rẻ🔥 Bao Giá & Bao Ship ",
    warn: "",
  },
];
export default dataFoodRice;
